import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { PerfectScrollbarModule } from "ngx-perfect-scrollbar";
import { OverlayPanelModule, TooltipModule } from "primeng/primeng";

import { NgAssetTagsComponent } from "./ng-asset-tags.component";
import { NgSearchSelectTagsComponent } from "./ng-search-select-tags/ng-search-select-tags.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        OverlayPanelModule,
        PerfectScrollbarModule.forChild(),
        TooltipModule,
        TranslateModule
    ],
    declarations: [
        NgAssetTagsComponent,
        NgSearchSelectTagsComponent
    ],
    exports: [
        NgAssetTagsComponent
    ]
})
export class NgAssetTagsModule { }
